import React from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import Main from './SubmitTimeslotMain';
import Success from './SubmitTimeslotSuccess';
import Fail from './SubmitTimeslotFail';

export default (data) => (
    <HashRouter>
        <Switch>
            <Route exact path="/" render={()=><Main resData={data.resData}/>} />
            <Route exact path="/submit" render={()=><Main resData={data.resData}/>} />
            <Route path="/success" exact component={ Success } />
            <Route path="/fail" render={()=><Fail resData={data.resData}/>} />
        </Switch>
    </HashRouter>
);